<div class="queue">

  <!-- Summary cards (unposted receipts; not affected by the filters) -->
  @if (Summary) {
  <div class="stat-cards">
    @if (mode === 'RECEIPTS') {
    <div class="summary-card card-process" [class.active]="Stage === 'PROCESSING'" (click)="setStage('PROCESSING')">
      <div class="summary-label">Processing</div>
      <div class="summary-value">{{ Summary.ProcessingCount }}</div>
      <div class="summary-sub">{{ Summary.ProcessingAmount | currency: 'USD' : 'symbol' : '1.2-2' }}</div>
    </div>
    <div class="summary-card card-unapplied" [class.active]="Stage === 'UNAPPLIED'" (click)="setStage('UNAPPLIED')">
      <div class="summary-label">Unapplied cash (unposted)</div>
      <div class="summary-value">{{ Summary.OpenUnappliedCount }}</div>
      <div class="summary-sub">{{ Summary.OpenUnappliedAmount | currency: 'USD' : 'symbol' : '1.2-2' }}</div>
    </div>
    <div class="summary-card card-entered" [class.active]="Stage === 'OPEN'" (click)="setStage('OPEN')">
      <div class="summary-label">Entered, not processing</div>
      <div class="summary-value">{{ Summary.EnteredCount }}</div>
    </div>
    } @else {
    <div class="summary-card card-bad">
      <div class="summary-label">Exceptions</div>
      <div class="summary-value">{{ Summary.ExceptionTabCount }}</div>
    </div>
    <div class="summary-card card-stale" [class.active]="ExceptionCode === 'STALE'" (click)="ExceptionCode = 'STALE'; applyFilters()">
      <div class="summary-label">Stale (old, unposted)</div>
      <div class="summary-value">{{ Summary.StaleCount }}</div>
      <div class="summary-sub">{{ Summary.StaleAmount | currency: 'USD' : 'symbol' : '1.2-2' }}</div>
    </div>
    <div class="summary-card card-process">
      <div class="summary-label">Set by a person</div>
      <div class="summary-value">{{ Summary.ExceptionCount }}</div>
    </div>
    }
  </div>
  }

  <!-- Stage buttons (Receipts tab only) -->
  @if (mode === 'RECEIPTS') {
  <div class="stage-row">
    @for (s of StageButtons; track s.key) {
    <button type="button" class="stage-btn" [class.active]="Stage === s.key" [disabled]="Loading" (click)="setStage(s.key)">{{ s.label }}</button>
    }
    <label class="stale-toggle" title="Receipts received more than 6 months ago and never posted (they also show on the Exceptions tab)">
      <input type="checkbox" [(ngModel)]="IncludeStale" (ngModelChange)="applyFilters()" [disabled]="Loading" />
      Include stale
    </label>
  </div>
  }

  <!-- Filters (server side) -->
  <div class="filters">
    <div class="f f-search">
      <label>Search</label>
      <rms-input name="Search" type="text" placeholder="Customer, receipt #, order #, check #, reference" [(ngModel)]="Search"></rms-input>
    </div>
    <div class="f">
      <label>Bank</label>
      <rms-select name="BankID" [options]="BankOptions" labelKey="label" valueKey="value" [(ngModel)]="BankID"></rms-select>
    </div>
    <div class="f">
      <label>Method</label>
      <rms-select name="PaymentMethodID" [options]="MethodOptions" labelKey="label" valueKey="value" [(ngModel)]="PaymentMethodID"></rms-select>
    </div>
    @if (mode === 'EXCEPTIONS') {
    <div class="f">
      <label>Exception</label>
      <rms-select name="ExceptionCode" [options]="ExceptionOptions" labelKey="label" valueKey="value" [(ngModel)]="ExceptionCode"></rms-select>
    </div>
    }
    <div class="f f-date">
      <label>Received from</label>
      <rms-date name="ReceivedFrom" label="" [(ngModel)]="ReceivedFrom"></rms-date>
    </div>
    <div class="f f-date">
      <label>Received to</label>
      <rms-date name="ReceivedTo" label="" [(ngModel)]="ReceivedTo"></rms-date>
    </div>
    <div class="f f-date">
      <label>Deposit from</label>
      <rms-date name="DepositFrom" label="" [(ngModel)]="DepositFrom"></rms-date>
    </div>
    <div class="f f-date">
      <label>Deposit to</label>
      <rms-date name="DepositTo" label="" [(ngModel)]="DepositTo"></rms-date>
    </div>
    <div class="f-buttons">
      <button class="btn-bg-blue" type="button" [disabled]="Loading" (click)="applyFilters()">Apply</button>
      <button class="btn-bg-slate" type="button" [disabled]="Loading" (click)="clearFilters()">Clear</button>
    </div>
  </div>

  <div class="count-line">
    @if (Loading) {
    Loading…
    } @else if (TotalRows > 0) {
    Showing {{ FirstRow | number }}–{{ LastRow | number }} of {{ TotalRows | number }} receipts. Click a row to open it.
    } @else {
    No receipts match.
    }
  </div>

  @if (Loaded) {
  <div class="table-wrap" [class.busy]="Loading">
    <rms-table [HeaderButtons]="Buttons"
               [parentContext]="this"
               [data]="Rows"
               [columns]="Columns"
               [pageSize]="100"
               [tableId]="TableId"
               [customizable]="true"
               [clickableRow]="true"
               (onRowClick)="openRow($event)">
    </rms-table>
  </div>
  }
</div>
